import { axios } from '@Root/API'

export const edit = (studyProgrammeId, sessionStatusId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/session-status/${sessionStatusId}`, payload)
}
